import { SVGProps } from '@components/Icon/types';

export const Versions = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M14.5175 8C14.9949 8 15.3276 8.47677 15.1647 8.92773L13.0075 14.9014C12.8646 15.2968 12.4903 15.5596 12.0717 15.5596H11.9901C11.5716 15.5595 11.1982 15.2966 11.0553 14.9014L8.89709 8.92773C8.73422 8.47677 9.06689 8 9.54426 8C9.83648 8.00001 10.0966 8.18577 10.1934 8.46289L12.0309 13.7256L13.8684 8.46289C13.9651 8.18591 14.2255 8.00019 14.5175 8Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3942 0C13.9417 4.31537e-05 14.4677 0.213603 14.8547 0.594727L19.827 5.4834C19.9095 5.56474 19.9656 5.66857 19.9883 5.78125C19.9924 5.8013 19.9981 5.89856 20 5.91895V17.4854C20 18.868 18.8487 20 17.4424 20H6.63687C5.44604 20 4.44074 19.1878 4.15995 18.0996H2.17666C0.982735 18.0995 0 17.1531 0 15.9883V4.01172C0 2.84694 0.982735 1.90046 2.17666 1.90039H4.15995C4.44074 0.81219 5.44604 0 6.63687 0H13.3942ZM6.63687 1.16406C5.87289 1.16406 5.26285 1.76349 5.26285 2.51465V17.4854C5.26285 18.2365 5.87289 18.8359 6.63687 18.8359H17.4424C18.2064 18.8359 18.8164 18.2365 18.8164 17.4854V8.21777L18.8116 6.47656H15.4776C14.8745 6.47639 14.3287 6.21731 13.9501 5.80762C13.6168 5.44665 13.4128 4.96852 13.4127 4.44629V1.17773L13.4049 1.17285L13.401 1.1709C13.3948 1.16713 13.3905 1.16514 13.3884 1.16406H6.63687ZM2.17666 3.03125C1.6074 3.03132 1.16024 3.46956 1.16024 4.01172V15.9883C1.16024 16.5304 1.6074 16.9687 2.17666 16.9688H4.07929V3.03125H2.17666ZM14.5972 4.44629C14.5975 4.93049 14.9852 5.31218 15.4776 5.3125H17.9788L14.5972 1.9873V4.44629Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'versions';
